import React, {useRef} from 'react';
import equal from 'fast-deep-equal';
import {ThemeColorName} from '@di-nxt/components';
import {BorderInfo} from '.';
import {Cell} from './Cell';

type Props<TCellData = any> = {
  prevCellDataRef: React.MutableRefObject<
    | {
        data: TCellData;
        component: React.ReactElement<any> | undefined;
      }[][]
    | undefined
  >;
  isHeader?: boolean;
  width?: number;
  height?: number;
  colIndex: number;
  rowIndex: number;
  colCount: number;
  rowCount: number;
  border?: BorderInfo;
  borderColor?: ThemeColorName;
  separatorColor?: ThemeColorName;
  onRenderCell: (
    row: number,
    col: number,
    cellInfo: TCellData,
  ) => React.ReactElement<any>;
  cellData: TCellData;
};

export const CellMemoizer = function <TCellData = any>(
  props: Props<TCellData>,
) {
  const {
    prevCellDataRef,
    cellData,
    onRenderCell,
    isHeader,
    width,
    height,
    border,
    colCount,
    colIndex,
    rowCount,
    rowIndex,
    borderColor,
    separatorColor,
  } = props;

  if (prevCellDataRef.current === undefined) {
    prevCellDataRef.current = [];
  }
  if (prevCellDataRef.current[rowIndex] === undefined) {
    prevCellDataRef.current[rowIndex] = [];
  }
  if (prevCellDataRef.current[rowIndex][colIndex] === undefined) {
    prevCellDataRef.current[rowIndex][colIndex] = {
      data: cellData,
      component: undefined,
    };
  }

  const cellInfoRef = prevCellDataRef.current[rowIndex][colIndex];
  const prevCellPropsRef = useRef<string>();
  const propsJson = JSON.stringify({
    isHeader,
    width,
    height,
    border,
    colCount,
    colIndex,
    rowCount,
    rowIndex,
    borderColor,
    separatorColor,
  });

  if (
    cellInfoRef.component === undefined ||
    !equal(cellInfoRef.data, cellData) ||
    propsJson !== prevCellPropsRef.current
  ) {
    prevCellPropsRef.current = propsJson;
    // if (cellInfoRef.component !== undefined) {
    //   console.log(
    //     'Cell Rerender',
    //     rowIndex,
    //     '/',
    //     rowCount,
    //     'changed',
    //     cellInfoRef.data,
    //     cellData,
    //   );
    // }
    cellInfoRef.data = cellData;
    cellInfoRef.component = (
      <Cell
        isHeader={isHeader}
        width={width}
        height={height}
        border={border}
        borderColor={borderColor}
        separatorColor={separatorColor}
        colIndex={colIndex}
        rowIndex={rowIndex}
        rowCount={rowCount}
        colCount={colCount}>
        {onRenderCell(rowIndex, colIndex, cellData)}
      </Cell>
    );
  }
  return cellInfoRef.component;
};
